import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../../components/icon';
var IconLink = React.forwardRef(function (props, ref) {
  return React.createElement(Icon, _extends({}, props, {
    content: {
      "16": {
        "height": 16,
        "width": 16,
        "source": "<path d=\"M6.23 10.77a1 1 0 0 1-.7-1.71l3.53-3.53a1 1 0 0 1 1.41 1.41l-3.53 3.53a1 1 0 0 1-.71.3z\"></path><path d=\"M4.82 15.18A4 4 0 0 1 2 8.35l1.76-1.76A1 1 0 0 1 5.17 8L3.4 9.77a2 2 0 0 0 2.83 2.83L8 10.83a1 1 0 0 1 1.41 1.41L7.65 14a4 4 0 0 1-2.83 1.18zM11.54 9.71a1 1 0 0 1-.71-.3 1 1 0 0 1 0-1.41l1.77-1.77A2 2 0 0 0 9.77 3.4L8 5.17a1 1 0 0 1-1.41-1.41L8.35 2A4 4 0 0 1 14 7.65l-1.76 1.76a1 1 0 0 1-.7.3z\"></path>"
      },
      "24": {
        "height": 24,
        "width": 24,
        "source": "<path d=\"M9.41 15.59a1 1 0 0 1-.71-.29 1 1 0 0 1 0-1.41l5.19-5.19a1 1 0 0 1 1.41 1.41l-5.19 5.19a1 1 0 0 1-.7.29z\"></path><path d=\"M7.65 22.19a5.85 5.85 0 0 1-4.11-10L6.1 9.57A1 1 0 0 1 7.53 11L5 13.58a3.86 3.86 0 1 0 5.45 5.47L13 16.47a1 1 0 0 1 1.4 1.43l-2.61 2.57a5.87 5.87 0 0 1-4.14 1.72zM17.19 14.73a1 1 0 0 1-.71-.29 1 1 0 0 1 0-1.41L19 10.42A3.86 3.86 0 1 0 13.59 5L11 7.53a1 1 0 0 1-1.41 0 1 1 0 0 1 0-1.42l2.61-2.57a5.86 5.86 0 1 1 8.28 8.3l-2.56 2.6a1 1 0 0 1-.73.29z\"></path>"
      }
    },
    ref: ref
  }));
});
IconLink.displayName = 'IconLink';
IconLink.defaultProps = {
  size: 16
};
export default IconLink;